import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Item from "../../components/Item";

/** Shared narrow column for data-deletion forms (matches /deletion-status width). */
export default function DataDeletionFormLayout({ children }) {
    return (
        <Box sx={{ display: "flex", justifyContent: "center", p: 6 }}>
            <Grid container spacing={2} sx={{ width: "100%", maxWidth: 720 }}>
                <Grid size={{ xs: 12 }}>
                    <Item sx={{ textAlign: "left" }}>{children}</Item>
                </Grid>
            </Grid>
        </Box>
    );
}
